<form [formGroup]="form">
  <div class="modal-header">
    <h4 class="modal-title" i18n>Request change</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
  </div>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-12">
        <label for="task" i18n>Change request</label>
        <textarea rows="5" id="task" class="form-control" formControlName="task"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" (click)="send()" i18n>Send request</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
  </div>
</form>